import { createApp } from 'vue'
import { store } from './vuex'
import { router } from "./router";
import { axios } from "./axios"
import VueAxios from 'vue-axios';

import VueAuth from '~/plugins/VueAuth';
import VueTabs from 'vue-nav-tabs';

import StringHelper from '~/helpers/StringHelper';
import ObjectHelper from '~/helpers/ObjectHelper';

import VueSidebarMenu from 'vue-sidebar-menu';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

import TopBar from "~/core/components/nav/TopBar";
import SideBar from "~/core/components/nav/SideBar";
import FooterBar from "./core/components/nav/FooterBar";
import LoadingIcon from "~/core/components/LoadingIcon";
import RouteTo from '~/core/components/routing/RouteTo';


require('./validation/emailIsAvailable.js');
require('./validation/validPassword.js');


const pending = {};



let Vue = createApp({});

Vue.component('top-bar', TopBar);
Vue.component('side-bar', SideBar);
Vue.component('footer-bar', FooterBar);
Vue.component('route-to', RouteTo);


Vue.use(VueSidebarMenu);
Vue.use(router);
Vue.use(store);
Vue.use(VueAxios, axios);
Vue.use(VueTabs);

store.axios = axios;

router.app = Vue;

if (document.getElementById('app') !== null) {
    Vue.mount('#app');
}

if (document.getElementById('legacyHeader') !== null) {
    Vue.mount('#legacySidebar');

    createApp(TopBar).use(store).mount('#legacyHeader');
    createApp(FooterBar).use(store).mount('#legacyFooter');
}
